import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexSweetalert',
  setup(__props) {

const basicAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/basicAlert.vue"))
const textUnder = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/textUnder.vue"))
const infoAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/infoAlert.vue"))
const warningAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/warningAlert.vue"))
const pikachuAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/pikachuAlert.vue"))
const questionsAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/questionsAlert.vue"))
const usernameAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/usernameAlert.vue"))
const successMessage = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/successMessage.vue"))
const dangerAlert = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/dangerAlert.vue"))
const warningMode = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/warningMode.vue"))
const autoClose = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/autoClose.vue"))
const requestMovie = defineAsyncComponent(() => import("@/components/theme/advance/sweealert/requestMovie.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      title: "Sweet Alert"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicAlert)),
        _createVNode(_unref(textUnder)),
        _createVNode(_unref(infoAlert)),
        _createVNode(_unref(warningAlert)),
        _createVNode(_unref(pikachuAlert)),
        _createVNode(_unref(questionsAlert)),
        _createVNode(_unref(usernameAlert)),
        _createVNode(_unref(successMessage)),
        _createVNode(_unref(dangerAlert)),
        _createVNode(_unref(warningMode)),
        _createVNode(_unref(autoClose)),
        _createVNode(_unref(requestMovie))
      ])
    ])
  ], 64))
}
}

})